import { fansupportPrivate } from "../index";
/**
 * Retrieves the count of unread notifications from the server.
 *
 * @return {Promise} A Promise that resolves to the count of unread notifications.
 */
export const getNotificationCount = async () => {
    return fansupportPrivate.get('/notification/unread-notifications-count')
}